<template>
  <v-dialog content-class="dialog-video" v-model="dialog" max-width="960">
    <template v-slot:activator="{ on, attrs }">
      <v-card
        v-bind="attrs"
        v-on="on"
        class="item"
        tile
        flat
        color="transparent"
        ><div class="relative">
          <img
            :src="`//img.youtube.com/vi/${getYoutubeCode(link)}/sddefault.jpg`"
            class="d-block item-img"
            width="100%"
          />
          <div class="d-flex align-center justify-center item-caption">
            <img
              class="d-block"
              src="../../assets/img/icons/play-bigger.png"
              :width="smAndDown ? 30 : 50"
            />
          </div>
        </div>
        <div
          class="
            font-weight-bold
            white--text
            text-center text-body-1 text-sm-h6
            py-3
          "
        >
          {{ title }}
        </div>
      </v-card>
    </template>

    <div class="black position-relative video">
      <div class="model-close">
        <v-btn
          @click="dialog = false"
          color="grey darken-3"
          width="38px"
          height="38px"
          depressed
          fab
        >
          <v-icon color="white" size="20"> fa-times </v-icon>
        </v-btn>
      </div>

      <iframe
        width="560"
        height="315"
        :src="
          dialog
            ? 'https://www.youtube.com/embed/' +
              getYoutubeCode(link) +
              '?autoplay=1'
            : ''
        "
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
  </v-dialog>
</template>

<script>
import { getYoutubeCode } from "../../utils/getYoutubeCode";

export default {
  props: {
    link: String,
    title: String,
  },
  data: () => ({
    dialog: false,
  }),
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    getYoutubeCode,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    aspect-ratio: 16 / 9;
    object-fit: cover;
    -o-object-fit: cover;
  }

  &-caption {
    background-color: rgba(0, 0, 0, 0.2);
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;

    img {
      opacity: 0.8;
      transition: all 0.1s linear;
    }
  }

  &:hover {
    .item-caption {
      img {
        opacity: 1;
      }
    }
  }
}
</style>
